
<span class="air-heading">Lead Engineering Overview</span>
<div class="screen-wrapper">
    <div class="section-wrapper">
        
<np-tabbed>
    <ul class="tabs">
        <li role="tab" aria-selected="true">Installed</li>
        <li role="tab" aria-selected="false">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
       <app-lead-engineer-installed [setData]="leadEngineerData"/>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-lead-engineer-removed [setData]="leadEngineerData"/>
    </div>

</np-tabbed>
        </div>

        <div class="section-wrapper">
            
<np-tabbed>
    <ul class="tabs">
        <li role="tab" aria-selected="true">Installed</li>
        <li role="tab" aria-selected="false">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
        <app-lead-engineer-installed-save [setData]="leadEngineerRemovedData"/>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-lead-engineer-removed-save [setData]="leadEngineerRemovedData"/>
    </div>

</np-tabbed>
        </div>
</div>